import { useMemo } from "react";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import AutocompleteField from "../../../components/Form/AutocompleteField";
import { useTranslationApp } from "../../../lib/i18next";
import { ADMIN_PRIMARY_KPI_OPTIONS } from "../../../utils/options";
import { GLOBAL_REPORT_MEASURABLE_KPI_ALL } from "../../../i18n/keysTranslations";
import { PILL_TRIGGER_VARIANT } from "../../../components/Buttons/PillTriggerButton";

const MeasurableKpiSelector = ({ control, disabled = false, errors = {} }) => {
  const { t } = useTranslationApp();

  const kpiOptions = useMemo(
    () =>
      ADMIN_PRIMARY_KPI_OPTIONS.map(({ value }) => ({
        value,
        label: value,
      })),
    []
  );

  return (
    <AutocompleteField
      name="measurableKpi"
      control={control}
      errors={errors}
      options={kpiOptions}
      doTranslate
      disabled={disabled}
      fullWidth={false}
      rules={{}}
      mode="text"
      showEmptyOption
      emptyOptionText={t(GLOBAL_REPORT_MEASURABLE_KPI_ALL)}
      defaultPlaceholderText={t(GLOBAL_REPORT_MEASURABLE_KPI_ALL)}
      onGetDisplayText={(field, options) => {
        if (!field?.value) {
          return t(GLOBAL_REPORT_MEASURABLE_KPI_ALL);
        }

        const selectedOption = options.find(
          (option) => option.value === field.value
        );

        return selectedOption ? t(selectedOption.label) : t(field.value);
      }}
      startIcon={
        <FilterListOutlinedIcon
          sx={{ fontSize: 14, color: "text.secondary" }}
        />
      }
      triggerVariant={PILL_TRIGGER_VARIANT.PILL}
      sx={{ width: { xs: "100%", sm: "auto" } }}
    />
  );
};

export default MeasurableKpiSelector;
